
	import { defineComponent } from 'vue';

	import FiscalYearReportByProgram from '@/ChildrenComponents/Reports/FiscalYearReportByProgram.vue';

	import { IProgramServedReport, IFiscalYearReportSearch } from '@/Models/Report/IPhaseReport';

    import { ReportService } from '@/Services/Report/report-service';

	export default defineComponent({
		name: 'program-served-report',
		components: { FiscalYearReportByProgram },
		data () {
			return {
				reportData: [] as IProgramServedReport[],
				isSearching: false,
			}
		},
		methods: {
			getReportData(searchDto: IFiscalYearReportSearch) {
				this.isSearching = true;
				ReportService.getProgramServedReportData(searchDto).then(response => this.reportData = response).finally(() => this.isSearching = false);
			}
		},
	});
